// import content from './content';
import { useState } from 'react';
import Button from '@CS/components/Button';
// import { useTranslation } from '@CS/hooks';
import type { CampaignState } from '@/redux/campaign/types';
import { Text, Title } from './PopUpErrorDeleteMember.styles';
import { type PopupProps, Popup } from '@CS/components/Popups';

type PopUpErrorDeleteMemberProps = PopupProps & {
  campaign: CampaignState;
};

export const PopUpErrorDeleteMember = ({ campaign, ...props }: PopUpErrorDeleteMemberProps) => {
  // const { title, text, button } = useTranslation(content);
  const [closed, setClosed] = useState(false);
  const onClick = () => setClosed(true);

  return (
    <Popup close={closed} {...props}>
      <Title>{campaign.translations.minimum_title}</Title>
      <Text>{campaign.translations.minimum_description}</Text>
      <Button onClick={onClick} text={campaign.translations.minimum_cta} />
    </Popup>
  );
};
